import { Tooltip, Typography } from '@mui/material';
import { formatDateLitteral } from 'helpers/format';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderWorkunit from 'types/entities/OrderWorkunit';

const ForcastedDateCell = React.memo((row: any) => {
  const [t] = useTranslation();

  const formattedForecastDate = row?.forecast_date
    ? formatDateLitteral(moment.utc(row?.forecast_date).format('YYYY/MM/DD'))
    : null;

  return (
    <Tooltip
      title={
        <span>
          {row?.forecast_date && formatDateLitteral(moment.utc(row?.forecast_date).format('YYYY/MM/DD').toString())}
          {!row?.forecast_date && row?.delivery_date && formatDateLitteral(row?.delivery_date)}
          {!row?.delivery_date && !row?.forecast_date && t('N/A')}
        </span>
      }
    >
      <Typography variant="body2" noWrap>
        {row?.forecast_date && formatDateLitteral(moment.utc(row?.forecast_date).format('YYYY/MM/DD').toString())}
        {!row?.forecast_date && row?.delivery_date && formatDateLitteral(row?.delivery_date)}
        {!row?.delivery_date && !row?.forecast_date && t('N/A')}
      </Typography>
    </Tooltip>
  );
});

export default ForcastedDateCell;
